import { apiRequest } from './index';

export const shiftRequestsAPI = {
  getAll: () => apiRequest("/shift-requests"),

  getMyRequests: () => apiRequest("/shift-requests/my-requests"),

  getByShiftId: (shiftId) =>
    apiRequest(`/shift-requests/shift/${shiftId}`),

  create: (shiftRequestData) =>
    apiRequest("/shift-requests", {
      method: "POST",
      body: shiftRequestData,
    }),

  updateStatus: (id, status) =>
    apiRequest(`/shift-requests/${id}/status`, {
      method: "PATCH",
      body: { status },
    }),

  delete: (id) =>
    apiRequest(`/shift-requests/${id}`, {
      method: "DELETE",
    })
};
